
import { Component, Vue } from 'vue-property-decorator';

import { Grid } from '@warrenbrasil/nebraska-web';

import { HomeTransactions } from '@/modules/home/components/HomeTransactions';
import { HomeStatements } from '@/modules/home/components/HomeStatements';

import { HomeSecondaryLinks } from '@/modules/home/components/HomeSecondaryLinks';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';

@Component({
  components: {
    HomeSecondaryLinks,
    HomeTransactions,
    HomeStatements,
    Grid
  }
})
export default class Homewidgets extends Vue {
  get isUnifiedAccountEnabled() {
    return FeatureFlagsModule.isEnabled(FeatureFlags.UNIFIED_ACCOUNT);
  }
}
